import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, Typography } from "@mui/material";
import MetricCard from "../../components/MetricCard/MetricCard";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import QualificadaIncremental from "./components/QualificadaIncremental";
import QualificadaCanal from "./components/QualificadaCanal";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

function QualificadaDesktop({ app }) {
  const { isLoading } = useOverviewData(app);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection="column"
            justifyContent="flex-start"
            rowGap={2}
          >
            {isLoading ? (
              <Grid container spacing={2} sx={{ marginTop: "37px" }}>
                {/* First row - 2 columns */}
                <Grid item xs={12} md={6} lg={3}>
                  <OverviewCardSkeleton variant="metrics" />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <OverviewCardSkeleton variant="metrics" />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <OverviewCardSkeleton variant="metrics" />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <OverviewCardSkeleton variant="metrics" />
                </Grid>

                {/* Second row - 4 equal columns */}
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
                <Grid item xs={12} md={6} xl={3}>
                  <OverviewCardSkeleton variant="rectangle" />
                </Grid>
              </Grid>
            ) : (
              <Grid item spacing={2} sx={{ marginTop: "37px" }}>
                <Box className="container-card-title">
                  <Typography variant="h1" className="title">
                    Cobertura qualificada
                  </Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={3}
                    sx={{ marginBottom: "20px" }}
                  >
                    <MetricCard
                      app={app}
                      nameCard={"Total indireto - atual"}
                      objectIds={{
                        porcente: "VhxgRhp",
                        metric01: "Jaqmk",
                        metric02: "kNBwzC",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <MetricCard
                      app={app}
                      nameCard={"Total indireto - LY"}
                      objectIds={{
                        porcente: "",
                        metric01: "",
                        metric02: "jPnFg",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <MetricCard
                      app={app}
                      nameCard={"Cobertura qualificada"}
                      objectIds={{
                        porcente: "tQVqeR",
                        metric01: "LbjkYz",
                        metric02: "phWcPx",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <MetricCard
                      app={app}
                      nameCard={"Atual vs LY"}
                      objectIds={{
                        porcente: "",
                        metric01: "",
                        metric02: "QdMHEt",
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} className="container-tables-tops">
                    <QualificadaIncremental app={app} />
                  </Grid>
                  <Grid item xs={12} md={6} className="container-tables-tops">
                    <QualificadaCanal app={app} />
                  </Grid>
                </Grid>
                <Grid item spacing={2}></Grid>
              </Grid>
            )}
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              height: "24vh",
              position: "relative",
            }}
          >
            <Footer app={app} customClass={"footer-qualificada"} />
          </Box>
        </LayoutWrapper>
      </div>
    </div>
  );
}

QualificadaDesktop.propTypes = {
  app: PropTypes.object,
};

export default QualificadaDesktop;
